export default __webpack_public_path__ + "static/media/1932.35e76629.png";